@if(status?.name) {
<span class="flex flex-row items-center gap-2">
  <span class="h-4 w-1 rounded-full shrink-0 opacity-80" [style.background-color]="status?.color || '#9ca3af'">
  </span>
  <span class="flex flex-col gap-0.5">
    <span class="text-xs leading-none">{{ status?.name }}</span>
    <span class="text-2xs leading-none opacity-80">{{ status?.date | date:'dd/MM/yyyy HH:mm' }}</span>
  </span>
</span>


}
